/* ========================================================================== */
/* File: src/components/layout/TopBar.js (Updated)              */
/* ========================================================================== */
import React, { useState, useEffect, useRef } from 'react';
import { Menu, LogOut } from 'lucide-react';

const TopBar = ({ user, onMenuClick, onLogout }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Use the user object passed down as a prop
    const userName = user ? `${user.firstName} ${user.lastName}` : "User"; 
    const userInitials = userName.split(' ').map(n => n[0]).join('');

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);

    return (
        <header className="top-bar">
            <button className="mobile-menu-button" onClick={onMenuClick}>
                <Menu size={24} color="var(--color-dark)" />
            </button>
            <div className="user-profile" ref={dropdownRef}>
                <span className="user-name">{userName} ({user?.role})</span> 
                <div onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                    <div className="user-avatar">{userInitials}</div>
                </div>
                
                {isDropdownOpen && (
                    <ul className="user-dropdown">
                        <li>
                            <button onClick={onLogout} className="dropdown-item">
                                <LogOut size={16} color="var(--color-text-light)"/>
                                <span>Logout</span>
                            </button>
                        </li>
                    </ul>
                )}
            </div>
        </header>
    );
};

export default TopBar;